import React from "react";
import { Table } from "react-bootstrap";
import useTax from "../Hooks/useTax";
import { useSelector } from "react-redux";
import useCartTotal from "../Hooks/useCartTotal";

const TotalPriceCard = ({ 
  deliveryType, 
  referralPercent,
  editableDelivery = false,
  deliveryOverride = null,
  onDeliveryOverrideChange = () => {},
  orderStatus = "", 
}) => {
  
  const [
    subtotal, 
    tax, 
    discount, 
    deliveryCharge, 
    total, 
    grossTotal, 
    referralDiscount
  ] = useTax(deliveryType, {referralPercent});
  
  const coupon = useSelector((x) => x.Coupon);
  const [amount, count] = useCartTotal();

  const canEdit = editableDelivery && orderStatus !== "delivered";
  const effectiveDelivery =
    deliveryOverride !== null ? Number(deliveryOverride || 0) : Number(deliveryCharge || 0);

  const computedTotal = 
    Math.round(subtotal || 0) +
    Math.round(tax || 0) +
    Math.round(effectiveDelivery || 0);
    // Math.round(effectiveDelivery || 0)+
    // Math.round(discount || 0) +
    // Math.round(referralDiscount || 0);
    
  const hasAppliedDiscount = Number(discount || 0) > 0;

  return (
    <>
      <div className="card-header border-0" style={{ backgroundColor: "#fff" }}>
        <Table borderless responsive className="mb-0">
          <tbody>
            <tr>
              <td className="fw-semibold">Total Items</td>
              <td className="fw-bold text-end">
                {count?.toLocaleString()} item(s)
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Item Price</td>
              <td className="fw-bold text-end">
                Rs. {amount?.toLocaleString()}
              </td>
            </tr>
            {/* <tr>
                          <td className="fw-semibold">
                            Total Price (Incl. Tax)
                          </td>
                          <td className="fw-bold text-end">
                            Rs. {amount?.toLocaleString()}
                          </td>
                        </tr> */}
          </tbody>
        </Table>
      </div>
      <hr className="mt-0" />
      <div className="card-body pt-0">
        <Table borderless responsive className="mb-0">
          <tbody>
            {/* <tr>
                          <td className="fw-semibold">
                            Total Price (Excl. Tax)
                          </td>
                          <td className="fw-bold text-end">
                            Rs. {Math.round(grossTotal)?.toLocaleString()}
                          </td>
                        </tr> */}
            {referralDiscount > 0 && (
              <tr style={{ backgroundColor: "#d0f0c0" }}>
                <td className="fw-semibold">Referral Discount</td>
                <td className="fw-bold text-end">- Rs. {Math.round(referralDiscount)?.toLocaleString()}</td>
              </tr>
            )}
            <tr>
              <td className="fw-semibold">Subtotal</td>
              <td className="fw-bold text-end">
                Rs. {Math.round(subtotal)?.toLocaleString()}
              </td>
            </tr>
            
            {/* {discount > 0 ? ( */}
            {hasAppliedDiscount ? (
              <tr>
                <td
                  className="fw-semibold"
                  style={{ backgroundColor: "#94e19459" }}
                >
                  Discount
                </td>
                <td
                  className="fw-bold text-end"
                  style={{ backgroundColor: "#94e19459" }}
                >
                  -Rs. {Math.round(discount)?.toLocaleString()}
                </td>
              </tr>
            ) : null}
            <tr>
              <td className="fw-semibold">VAT / Tax</td>
              <td className="fw-bold text-end">
                Rs. {Math.round(tax)?.toLocaleString()}
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Delivery Fee</td>
              <td className="fw-bold text-end">
                {/* Rs. {deliveryCharge?.toLocaleString()} */}
                {canEdit ? (
                  <input
                    type="number"
                    min="0"
                    step="1"
                    value={effectiveDelivery}
                    onChange={(e) => onDeliveryOverrideChange(e.target.value)}
                    style={{
                      width: 110,
                      textAlign: "right",
                      padding: "4px 8px",
                      borderRadius: 6,
                      border: "1px solid #ddd",
                    }}
                  />
                ) : (
                  <>Rs. {Number(deliveryCharge || 0)?.toLocaleString()}</>
                )}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <hr className="my-0" />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Total</td>
              <td className="fw-bold text-end">
                {/* Rs. {Math.round(total)?.toLocaleString()} */}
                Rs. {Math.round(canEdit ? computedTotal : total)?.toLocaleString()}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default TotalPriceCard;
